import { render, staticRenderFns } from "./PreviewHeader.vue?vue&type=template&id=706870d9&scoped=true"
import script from "./PreviewHeader.vue?vue&type=script&lang=js"
export * from "./PreviewHeader.vue?vue&type=script&lang=js"
import style0 from "./PreviewHeader.vue?vue&type=style&index=0&id=706870d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706870d9",
  null
  
)

export default component.exports